export { IntentionsPrayFlow as default } from '@/src/features/intention/ui/screens/IntentionsPrayFlowScreen/IntentionsPrayFlow'
